import {useMutation} from "@tanstack/react-query";
import {returnCustomerOfferToCoefficientReviewMutationOptions} from "./return-customer-offer-to-coefficient-review.mutation-options";

export function useReturnCustomerOfferToCoefficientReview() {
  return useMutation(returnCustomerOfferToCoefficientReviewMutationOptions());
}
